<div class="card flex justify-center">
  <p-toggleButton
    styleClass="dark-toggleButton"
    [(ngModel)]="checked"
    [offIcon]="'pi pi-sun'"
    [onIcon]="'pi pi-moon'"
    size="large"
    (click)="switchTheme()"
  />
</div>